export const TodosTypes = {
  unclaimedRescue: 'unclaimed_rescue',
  unassignedRescue: 'unassigned_rescue',
  pendingFoodDonorRegistration: 'pending_food_donor_registration',
  pendingDonationRequest: 'pending_donation_request',
  firstRescues: 'first_time_rescue',
  substitutionRescues: 'substitution_rescue',
  irregularRescues: 'irregular_rescue',
  reviewPickupSchedule: 'review_pickup_schedule',
};
